import { systemDesignForOrientation } from "./orientations";

// A face's proposal contains padded, empty MPPTs belonging to other faces.
// Merge only its own MPPTs; those placeholders must never erase another roof.
export function mergePlanDesign(design, fitted, orientations, id) {
  const scoped = systemDesignForOrientation(design, orientations, id);
  const primary = orientations[0].id;
  return Object.fromEntries(Object.entries(design).map(([key, mppts]) => [key, mppts.map((m, i) => {
    if ((m.orientation || primary) !== id || !scoped?.[key]?.[i]) return m;
    const candidate = fitted?.[key]?.[i];
    if (!candidate || Number(candidate.index ?? i + 1) !== Number(m.index ?? i + 1)) throw new Error("Invalid string proposal");
    return { ...m, inputs: candidate.inputs };
  })]));
}

export function structuredPlanDesign(systemDesign, previous, module, inverter) {
  const keys = Object.keys(systemDesign);
  const layout = Object.values(systemDesign).map((mppts, inv) => mppts.map((m, mi) => {
    const inputs = (m.inputs || []).filter(i => Number(i.modules_per_string ?? i.modulesPerString) > 0);
    const size = Math.max(previous?.layout?.[inv]?.[mi]?.inputs?.length || 0, ...inputs.map(i => Number(i.index) || 1), 0);
    return { modulesPerString: inputs[0]?.modules_per_string ?? inputs[0]?.modulesPerString ?? "",
      inputs: Array.from({ length: size }, (_, i) => ({ used: inputs.some(p => Number(p.index ?? 1) === i + 1) })),
      ...(m.orientation ? { orientation: m.orientation } : {}) };
  }));
  return { module, inverter, nInverters: keys.length, inverterOrder: keys, layout,
    layoutByInverter: Object.fromEntries(keys.map((key, i) => [key, layout[i]])) };
}
